/* eslint-disable */
import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { NavLink, useLocation } from 'react-router-dom';
import { ListItem, Collapse, Hidden, Box } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ImageListItem from '@mui/material/ImageListItem';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DescriptionIcon from '@mui/icons-material/Description';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import SummarizeIcon from '@mui/icons-material/Summarize';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { list } from 'postcss';
import MobileSidebar from './MobileSidebar';
import inetlogo from '../../assets/images/inetlogo.png';
import SettingsIcon from '@mui/icons-material/Settings';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
const drawerWidth = 300;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  backgroundColor: '#007CC2',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  backgroundColor: '#007CC2',
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',

  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

const items = [
  {
    href: '/transaction',
    icon: DescriptionIcon,
    title: 'Transaction',
    sub: [],
  },
  // {
  //   href: '',
  //   icon: DescriptionIcon,
  //   title: 'Report',
  //   sub: [
  //     {
  //       href: '/operation-report',
  //       icon: StarOutlineIcon,
  //       title: 'OperationReport',
  //     },
  //   ],
  // },
  // {
  //   href: '/balance',
  //   icon: AccountBalanceWalletIcon,
  //   title: 'Balance',
  //   sub: [],
  // },
  // {
  //   href: '/',
  //   icon: EqualizerIcon,
  //   title: 'Withdrow',
  //   sub: [],
  // },
  {
    href: '/dashboard',
    icon: EqualizerIcon,
    title: 'Dashboard',
    sub: [],
  },
  {
    href: '/list-merchant',
    icon: ListAltIcon,
    title: 'Merchant Information',
    sub: [],
  },
];

export default function MiniDrawer({
  onMobileClose,
  openMobile,
  children,
  open,
  setOpen,
}) {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [openSubSidebar, setOpenSubSidebar] = useState('');

  const location = useLocation();

  //*แบบที่ 1 กด button แล้วแสดง พอกด button ไหนก็ตามอันเก่าจะถูกปิด
  // const handleClick = (item) => {
  //   setOpenSidebar(!openSidebar);
  //   setOpenSubSidebar(item.title);
  // };

  ///*แบบที่ 2 กด button แล้วแสดง พอกดอันใหม่ จะแสดงอันใหม่ พร้อมกับปิดอันเก่า
  // const handleClick = (item) => {
  //   if (openSubSidebar === item.title) {
  //     // ถ้าเมื่อคลิกแล้ว sub menu เปิดอยู่แล้ว
  //     setOpenSubSidebar(''); // ปิด sub menu
  //   } else {
  //     setOpenSubSidebar(item.title); // เปิด sub menu ใหม่
  //   }
  // };

  //*แบบที่ 3 กด button แล้วแสดง พอกดอันใหม่ อันใหม่ก็แสดง อันเก่าก็ยังอยู่ ยกเว้นไปกดอันเดิมซ้ำ จะปิด
  const handleClick = (item) => {
    if (openSubSidebar.includes(item.title)) {
      setOpenSubSidebar(openSubSidebar.filter((title) => title !== item.title)); // ปิด sub menu เมื่อคลิกที่เดิม
    } else {
      setOpenSubSidebar([...openSubSidebar, item.title]); // เปิด sub menu ใหม่เมื่อคลิกที่ใหม่
    }
  };

  const isSubSidebarOpen = (title) => openSubSidebar.includes(title); //*แบบที่ 3 กด button แล้วแสดง พอกดอันใหม่ อันใหม่ก็แสดง อันเก่าก็ยังอยู่ ยกเว้นไปกดอันเดิมซ้ำ จะปิด
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const renderSubItems = (subItems, margin) =>
    subItems.map((subItem, index) => (
      <div key={index}>
        {subItem?.sub?.length > 0 ? (
          <div>
            <ListItem
              className="hover:bg-sky-500 cursor-pointer"
              sx={{ color: '#F5F5F5', marginLeft: margin, fontSize: '16px' }} //ลูกศรด้านใน
              onClick={() => handleClick(subItem)}
            >
              {/* ไอคอนหัวข้อ */}
              <ListItemIcon sx={{ color: '#F5F5F5', fontSize: '16px' }}>
                <subItem.icon />
              </ListItemIcon>
              <ListItemText
                primary={subItem.title}
                sx={{ marginLeft: -1, color: '#fff' }}
              />

              {/* *แบบที่ 1 กด button แล้วแสดง พอกด button ไหนก็ตามอันเก่าจะถูกปิดา */}
              {/* {openSidebar && openSubSidebar === item.title ? (
              <ExpandLess />
            ) : (
              <ExpandMore />
            )} */}

              {/* *แบบที่ 2 กด button แล้วแสดงพอกดอันใหม่ จะแสดงอันใหม่ พร้อมกับปิดอันเก่า */}
              {/* in={openSubSidebar === item.title} */}

              {/* //*แบบที่ 3 กด button แล้วแสดง พอกดอันใหม่ อันใหม่ก็แสดงอันเก่าก็ยังอยู่ ยกเว้นไปกดอันเดิมซ้ำ จะปิด */}
              {isSubSidebarOpen(subItem.title) ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )}
            </ListItem>

            <Collapse
              //* //*แบบที่ 1 กด button แล้วแสดง พอกด button ไหนก็ตามอันเก่าจะถูกปิด
              // in={openSidebar && openSubSidebar === item.title}

              //*แบบที่ 2 กด button แล้วแสดง พอกดอันใหม่ จะแสดงอันใหม่ พร้อมกับปิดอันเก่า
              // in={openSubSidebar === item.title}

              //*แบบที่ 3 กด button แล้วแสดง พอกดอันใหม่ อันใหม่ก็แสดง อันเก่าก็ยังอยู่ ยกเว้นไปกดอันเดิมซ้ำ จะปิด
              in={isSubSidebarOpen(subItem.title)}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                {renderSubItems(subItem.sub, margin + 2)}
              </List>
            </Collapse>
          </div>
        ) : (
          <NavLink to={subItem.href} key={index}>
            <ListItem
              className="hover:bg-sky-500 cursor-pointer"
              sx={{
                ...(subItem.href === location.pathname && {
                  backgroundColor: '#6FBAE9',
                  borderRadius: 3,
                  color: '#FFF',
                }),
              }}
            >
              <ListItemIcon>
                {subItem.href === location.pathname ? (
                  <subItem.icon sx={{ color: '#fff', marginLeft: margin }} />
                ) : (
                  <subItem.icon sx={{ marginLeft: margin, color: '#F5F5F5' }} /> //ไอคอนดาว
                )}
              </ListItemIcon>
              <ListItemText
                primary={subItem.title}
                sx={{ marginLeft: margin - 1, color: '#fff' }} //ชื่อหัวข้อตรงไอคอนดาว
              />
            </ListItem>
          </NavLink>
        )}
      </div>
    ));

  const renderItems = () =>
    items.map((item, index) => (
      <div key={index}>
        {item.sub.length > 0 ? (
          <div>
            <ListItem
              className="hover:bg-sky-500 cursor-pointer"
              onClick={() => handleClick(item)}
              sx={{ marginLeft: -0.2, color: '#F5F5F5' }} //ลูกศรด้านนอก
            >
              {/* ไอคอนหัวข้อ */}
              <ListItemIcon sx={{ color: '#F5F5F5' }}>
                <item.icon />
              </ListItemIcon>
              <ListItemText
                primary={item.title}
                sx={{ marginLeft: -1, color: '#fff' }}
              />

              {/* *แบบที่ 1 กด button แล้วแสดง พอกด button ไหนก็ตามอันเก่าจะถูกปิดา */}
              {/* {openSidebar && openSubSidebar === item.title ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )} */}

              {/* *แบบที่ 2 กด button แล้วแสดงพอกดอันใหม่ จะแสดงอันใหม่ พร้อมกับปิดอันเก่า */}
              {/* in={openSubSidebar === item.title} */}

              {/* //*แบบที่ 3 กด button แล้วแสดง พอกดอันใหม่ อันใหม่ก็แสดงอันเก่าก็ยังอยู่ ยกเว้นไปกดอันเดิมซ้ำ จะปิด */}
              {isSubSidebarOpen(item.title) ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse
              //* //*แบบที่ 1 กด button แล้วแสดง พอกด button ไหนก็ตามอันเก่าจะถูกปิด
              // in={openSidebar && openSubSidebar === item.title}

              //*แบบที่ 2 กด button แล้วแสดง พอกดอันใหม่ จะแสดงอันใหม่ พร้อมกับปิดอันเก่า
              // in={openSubSidebar === item.title}

              //*แบบที่ 3 กด button แล้วแสดง พอกดอันใหม่ อันใหม่ก็แสดง อันเก่าก็ยังอยู่ ยกเว้นไปกดอันเดิมซ้ำ จะปิด
              in={isSubSidebarOpen(item.title)}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                {renderSubItems(item.sub, 2)}
              </List>
            </Collapse>
          </div>
        ) : (
          <NavLink to={item.href}>
            <ListItem
              className="hover:bg-sky-500 cursor-pointer"
              //*เพิ่มสี แท็บธรรมดา
              // onClick={() => handleClick(item)}
              sx={{
                ...(item.href === location.pathname && {
                  backgroundColor: '#6FBAE9',
                  borderRadius: 3,
                  color: '#FFF',
                }),
              }}
            >
              <ListItemIcon>
                {/* <item.icon /> */}
                {item.href === location.pathname ? (
                  <item.icon />
                ) : (
                  <item.icon sx={{ color: '#F5F5F5' }} /> //ไอคอนหัวข้อ
                )}
              </ListItemIcon>
              <ListItemText
                primary={item.title}
                sx={{ marginLeft: -1, color: '#fff' }}
              />
            </ListItem>
          </NavLink>
        )}
      </div>
    ));

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Hidden lgDown>
        <Drawer variant="permanent" open={open}>
          <ListItem disablePadding sx={{ display: 'flex' }}>
            <ListItemButton
              onClick={() => {
                if (open) {
                  handleDrawerClose();
                } else {
                  handleDrawerOpen();
                }
              }}
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                color: '#fff', //ชื่อบริษัท
              }}
            >
              <ImageListItem sx={{ maxWidth: open ? '60px' : '70px' }}>
                <img src={`${inetlogo}`} />
              </ImageListItem>
              <ListItemText
                sx={{ opacity: open ? 1 : 0, ml: open ? '10px' : 0 }}
              >
                <div className="text-sm">Internet Thailand</div>
                <div className="text-sm">Public Company Limited</div>
              </ListItemText>
            </ListItemButton>
          </ListItem>
          <List sx={{}}>{renderItems()}</List>
        </Drawer>
      </Hidden>

      <Hidden lgUp>
        <MobileSidebar
          onMobileClose={onMobileClose}
          openMobile={openMobile}
          items={items}
        />
      </Hidden>

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  );
}
